module.exports = __webpack_public_path__ + "img/flag4.43779bae.gif";